import React from 'react';
import { useTheme } from '../context/ThemeContext';

/**
 * Modern Shared Oxygen logo with interlocking circles
 * Represents the interconnected nature of AI, Data, and Agentic services
 */
const Logo = ({
  className = "",
  width = "auto",
  height = "auto",
  maxWidth = "180px",
  alt = "Shared Oxygen"
}) => {
  const { theme } = useTheme();

  const combinedClassName = `logo ${className}`;
  const actualWidth = width === 'auto' ? maxWidth : width;
  const actualHeight = height === 'auto' ? undefined : height; // Pass undefined instead of 'auto' for SVG

  const logoSvgProps = {
    viewBox: "0 0 400 400",
    width: actualWidth,
    className: combinedClassName,
    style: {
      maxWidth,
      display: 'block',
    },
    'aria-label': alt
  };
  
  // Only add height if it's not undefined/null and not 'auto'
  if (actualHeight && actualHeight !== 'auto') {
    logoSvgProps.height = actualHeight;
  }

  return (
    <svg {...logoSvgProps}>
      {/* Four interlocking circles */}
      
      {/* Top circle - Blue (AI Advisory) */}
      <circle 
        cx="200" 
        cy="100" 
        r="70" 
        fill="none" 
        stroke="url(#blueGradient)" 
        strokeWidth="14" 
        opacity="0.9"
      />
      
      {/* Left circle - Green (Data Advisory) */}
      <circle 
        cx="150" 
        cy="180" 
        r="70" 
        fill="none" 
        stroke="url(#greenGradient)" 
        strokeWidth="14" 
        opacity="0.9"
      />
      
      {/* Right circle - Orange (Agentic AI) */}
      <circle 
        cx="250" 
        cy="180" 
        r="70" 
        fill="none" 
        stroke="url(#orangeGradient)" 
        strokeWidth="14" 
        opacity="0.9"
      />
      
      {/* Bottom circle - Purple (Integration) */}
      <circle 
        cx="200" 
        cy="220" 
        r="50" 
        fill="none" 
        stroke="url(#purpleGradient)" 
        strokeWidth="10" 
        opacity="0.7"
      />
      
      
      {/* Company name - positioned below circles */}
      <text 
        x="200" 
        y="350" 
        textAnchor="middle" 
        fill={theme === 'dark' ? '#e2e8f0' : '#374151'} 
        fontFamily="Inter, sans-serif" 
        fontSize="42" 
        fontWeight="700" 
        letterSpacing="0.5px"
      >
        Shared Oxygen
      </text>
      
      
      {/* Gradient definitions */}
      <defs>
        <linearGradient id="blueGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#60a5fa" stopOpacity="1" />
          <stop offset="100%" stopColor="#3b82f6" stopOpacity="1" />
        </linearGradient>
        
        <linearGradient id="greenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#34d399" stopOpacity="1" />
          <stop offset="100%" stopColor="#10b981" stopOpacity="1" />
        </linearGradient>
        
        <linearGradient id="orangeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fbbf24" stopOpacity="1" />
          <stop offset="100%" stopColor="#f59e0b" stopOpacity="1" />
        </linearGradient>
        
        <linearGradient id="purpleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#a78bfa" stopOpacity="1" />
          <stop offset="100%" stopColor="#8b5cf6" stopOpacity="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Logo;
